import { Component, Input, OnInit } from '@angular/core';
import { Globals } from 'src/app/globals';

@Component({
  selector: 'app-cand-card',
  templateUrl: './cand-card.component.html',
  styleUrls: ['./cand-card.component.scss']
})
export class CandCardComponent implements OnInit {

  @Input() candData: any;
  // candData = {
  //   "id": 0,
  //   "orgid": 0,
  //   "yearid": 0,
  //   "semesterid": 0,
  //   "appstatusid": 0,
  //   "candCode": "string",
  //   "sec1Entrydate": "2021-07-17T12:52:27.082Z",
  //   "countryid": 0,
  //   "nidNo": "string",
  //   "emailAddress1": "string",
  //   "emailValidated": "string",
  //   "emailValidateDate": "2021-07-17T12:52:27.082Z",
  //   "fullNameAr": "string",
  //   "fullNameEn": "string",
  //   "dob": "2021-07-17T12:52:27.082Z",
  //   "gender": "string",
  //   "addressL1Ar": "string",
  //   "addressL1En": "string",
  //   "addressL2Ar": "string",
  //   "addressL2En": "string",
  //   "addressCountryid": 0,
  //   "addressRegionid": 0,
  //   "addressProvinceid": 0,
  //   "addressCityid": 0,
  //   "maritalStatusid": 0,
  //   "personalMob1": "string",
  //   "personalMob2": "string",
  //   "emergencyMob1": "string",
  //   "emergencyMob2": "string",
  //   "emergencyContact1": "string",
  //   "emergencyContact2": "string",
  //   "homeTel": "string",
  //   "emailAddress2": "string",
  //   "milStatusid": 0,
  //   "milStatusNote": "string",
  //   "sec1NotesAr": "string",
  //   "sec1NotesEn": "string",
  //   "photoFilename": "string",
  //   "sec2Entrydate": "2021-07-17T12:52:27.082Z",
  //   "livewithid": 0,
  //   "livewithOther": "string",
  //   "relative1Mob": "string",
  //   "relation1": "string",
  //   "relative2Mob": "string",
  //   "relation2": "string",
  //   "siblingsCount": 0,
  //   "candSiblingsRank": 0,
  //   "knowAboutOrg": "string",
  //   "sec3Entrydate": "2021-07-17T12:52:27.082Z",
  //   "bachlorScore": 0,
  //   "bachlorPercent": 0,
  //   "bachlorCertFilename": "string",
  //   "bachlorCardFilename": "string",
  //   "termsAccepted": "string",
  //   "termsAcceptedBy": "string",
  //   "termsAcceptedOn": "2021-07-17T12:52:27.082Z",
  //   "interviewDate": "2021-07-17T12:52:27.082Z",
  //   "interviewVduLink": "string",
  //   "interviewRscore": "string",
  //   "interviewRscoreWegiht": 0,
  //   "interviewComment": "string",
  //   "attitudeRscore": "string",
  //   "attitudeComment": "string",
  //   "medicalDate": "2021-07-17T12:52:27.082Z",
  //   "medicalStatus": "string",
  //   "medicalComment": "string",
  //   "acceptanceDate": "2021-07-17T12:52:27.082Z",
  //   "acceptanceStatus": "string",
  //   "acceptanceComment": "string",
  //   "dictId": 0
  // };

  constructor(public globals: Globals) { }

  ngOnInit(): void {
  }

  checkDataExist() {
    // console.log(this.candData);
    return (typeof this.candData === 'object' && this.candData !== null)
  }
}
